import * as React from "react";

// Ported from shadcn/ui Textarea component API and adapted to Tailwind with safe prefix (tw-)
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    className?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, ...props }, ref) => {
        const clx = [
            "tw-block tw-min-h-[100px] tw-w-full tw-max-w-full tw-min-w-0 tw-rounded-lg tw-box-border",
            "tw-border tw-border-gray-300 tw-bg-white",
            "tw-px-3 tw-py-2 tw-text-base tw-text-gray-900 placeholder:tw-text-gray-400",
            "focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary/30 focus:tw-border-primary",
            "disabled:tw-cursor-not-allowed disabled:tw-opacity-60",
            "tw-resize-y tw-transition tw-duration-150 tw-ease-in-out",
            className || "",
        ]
            .filter(Boolean)
            .join(" ");

        return <textarea ref={ref} className={clx} {...props} />;
    },
);

Textarea.displayName = "Textarea";

export default Textarea;
